import styled from "styled-components";
import {Button} from "../../../../../basic-ui-components/button/base/button.component";
import {CssRule} from "../../../../../themes/architecture/css-helpers/css-rule";

export const SimpleMessageDialogButtonBox = styled(Button)<{buttonWidthProportionOnPC: number}>`
    margin-right: 40px;
    ${CssRule.For.RTL.build()} & {
      margin-right: 0;
      margin-left: 40px;
    }
    width: ${props => 100/props.buttonWidthProportionOnPC}%;
    &:last-of-type {
      margin-right: 0;
      ${CssRule.For.RTL.build()} & {
        margin-left: 0;
      }
    }


    @media ${props => props.theme.mediaQuery.sAndBelow} {
        width: 100%;
        &:last-of-type {
          margin-right: 0;
          margin-top: 20px;
          ${CssRule.For.RTL.build()} & {
            margin-left: 0;
          }
        }
    }
`